
/**
 * Automatic function for youtube widget.
 * @param {type} $
 * @returns {undefined}
 */
(function($) {

  /**
   * Show a YouTube video inside of a magnific popup
   */
  window.showYouTube = function(youTubeId, el) {
    var aspectRatio = 9/16;
    var iFrameWidth = parseInt($(document).innerWidth() * 0.65);
    var iFrameHeight = parseInt(iFrameWidth * aspectRatio);

    var iframeStr = '<section class="video video-js vjs-default-skin vjs-big-play-centered ">' +
                      '<iframe id="youtube-embed-' + youTubeId + '" height="' + iFrameHeight + '" width="' + iFrameWidth + '" ' +
                            'src="https://www.youtube.com/embed/' + youTubeId + '?enablejsapi=1&autoplay=1" ' +
                      'frameborder="0" allowfullscreen></iframe>' +
                    '</section>';
    var frmObj = jQuery(iframeStr);

    // Show a popup.
    jQuery('<a>').magnificPopup({
      alignTop: false,
      showCloseBtn: true,
      fixedBgPos: true,
      preloader: true,
      disableOn: 480,
      items: {
        src: frmObj,
        type: 'inline'
      },
      callbacks: {
        // Open callback
        open: function() {
          $('.mfp-content').css({
            width: parseInt($(window).innerWidth() * 0.75) + 'px',
            height: frmObj.height() + 'px'
          });
          $('.mfp-close').css({
            top: '-45px'
          });
        },
        // Close callback
        close: function() {}
      }
    }).click();

  };

})(jQuery);

